import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2021十大重庆经济年度人物评选';
const baseUrl = '0408JJRW';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/rules`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/NewsList.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },

    {
      path: 'detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'peopleDetail',
      name: `${baseUrl}-peopleDetail`,
      component: () => import('./pages/PeopleDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'caseDetail',
      name: `${baseUrl}-caseDetail,`,
      component: () => import('./pages/CaseDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
  ],
};

export default route;
